import React, { useState, useEffect } from "react";
import { Search, LogOut, ChevronLeft, ChevronRight, Trash2 } from "lucide-react";
import Swal from "sweetalert2";
import "../Styles/collaborateList.css";

const API_BASE_URL = "";

// ---- Dummy data (used when the API is unreachable, so the UI can be
// previewed before the backend endpoints exist) ----
const DUMMY_COLLABORATORS = [
  { id: 1, companyName: "Edupact Learnings", contactName: "Shobaan Chakravarthi M", contactNumber: "87544 18571", businessEmail: "shobaan@edupactlearnings.com", websiteLink: "https://edupactlearnings.com", privacyAgreed: true, companyOverview: "Edupact Learnings (formerly Sshutanus Academy of Speaking Arts) is a learning and development organization focused on communication, leadership, employability, and workplace effectiveness for students, professionals, and corporates." },
  { id: 2, companyName: "Frutta", contactName: "Madhu Harshni M", contactNumber: "9043867785", businessEmail: "madhu.harshni@frutta.in", websiteLink: "https://frutta.in", privacyAgreed: true, companyOverview: "Frutta is a corporate food and beverage aggregator serving leading corporates with curated refreshment solutions for offices and events." },
  { id: 3, companyName: "Sunsaga", contactName: "Madhu Harshni M", contactNumber: "9043867785", businessEmail: "madhu.harshni@sunsaga.in", websiteLink: "https://sunsaga.in", privacyAgreed: true, companyOverview: "Sunsaga specializes in corporate gifting, employee engagement solutions, and CSR activities for organizations across India." },
  { id: 4, companyName: "TalentBridge Consulting", contactName: "Ravi Shankar", contactNumber: "9884123456", businessEmail: "ravi@talentbridge.co.in", websiteLink: "https://talentbridge.co.in", privacyAgreed: true, companyOverview: "TalentBridge Consulting connects growing companies with recruitment strategy, workforce planning, and HR advisory services." },
  { id: 5, companyName: "WellSpace Wellness", contactName: "Anita Desai", contactNumber: "9791987654", businessEmail: "anita@wellspace.in", websiteLink: "https://wellspace.in", privacyAgreed: false, companyOverview: "WellSpace Wellness brings corporate wellness programs, mental health workshops, and on-site fitness sessions to workplaces." },
  { id: 6, companyName: "CodeCraft Academy", contactName: "Suresh Kumar", contactNumber: "9600445566", businessEmail: "suresh@codecraft.in", websiteLink: "https://codecraft.in", privacyAgreed: true, companyOverview: "CodeCraft Academy offers upskilling bootcamps in software development, data science, and cloud technologies for working professionals." },
  { id: 7, companyName: "GreenLeaf Catering", contactName: "Kavitha Rajan", contactNumber: "9843556677", businessEmail: "kavitha@greenleaf.in", websiteLink: "https://greenleafcatering.in", privacyAgreed: true, companyOverview: "GreenLeaf Catering provides sustainable, farm-to-table catering services for corporate events and conferences." },
  { id: 8, companyName: "NextGen Staffing", contactName: "Mohammed Yusuf", contactNumber: "9884998877", businessEmail: "yusuf@nextgenstaffing.com", websiteLink: "https://nextgenstaffing.com", privacyAgreed: true, companyOverview: "NextGen Staffing provides contract and permanent staffing solutions across IT, manufacturing, and BFSI sectors." },
  { id: 9, companyName: "Zenith Office Interiors", contactName: "Deepak Menon", contactNumber: "9600778899", businessEmail: "deepak@zenithinteriors.in", websiteLink: "https://zenithinteriors.in", privacyAgreed: true, companyOverview: "Zenith Office Interiors designs and fits out modern, ergonomic workspaces for startups and enterprises." },
  { id: 10, companyName: "PulseHR Software", contactName: "Nandini Sridhar", contactNumber: "9791223344", businessEmail: "nandini@pulsehr.io", websiteLink: "https://pulsehr.io", privacyAgreed: true, companyOverview: "PulseHR Software builds cloud-based HRMS tools for payroll, attendance, and performance management." },
  { id: 11, companyName: "Bright Minds Publishing", contactName: "Vishal Aggarwal", contactNumber: "9840667711", businessEmail: "vishal@brightminds.in", websiteLink: "https://brightminds.in", privacyAgreed: false, companyOverview: "Bright Minds Publishing creates learning content, case studies, and books for management and HR education." },
  { id: 12, companyName: "UrbanTravel Corporate", contactName: "Fathima Noor", contactNumber: "9884556678", businessEmail: "fathima@urbantravel.in", websiteLink: "https://urbantravel.in", privacyAgreed: true, companyOverview: "UrbanTravel Corporate manages business travel, event logistics, and delegate accommodation for conferences." },
  { id: 13, companyName: "SkillForge Training", contactName: "Aravind Bose", contactNumber: "9600889900", businessEmail: "aravind@skillforge.in", websiteLink: "https://skillforge.in", privacyAgreed: true, companyOverview: "SkillForge Training delivers soft-skills, leadership, and compliance training programs for corporate teams." },
  { id: 14, companyName: "Bluewave Media", contactName: "Sneha Pillai", contactNumber: "9791667788", businessEmail: "sneha@bluewavemedia.in", websiteLink: "https://bluewavemedia.in", privacyAgreed: true, companyOverview: "Bluewave Media handles event photography, videography, and live-streaming for corporate summits and conferences." },
  { id: 15, companyName: "CivicWorks CSR Foundation", contactName: "Ramesh Iyengar", contactNumber: "9843112233", businessEmail: "ramesh@civicworks.org", websiteLink: "https://civicworks.org", privacyAgreed: true, companyOverview: "CivicWorks CSR Foundation partners with corporates to design and execute community development and CSR initiatives." },
];

export default function CollaborateList() {
  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [query, setQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchCollaborators = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/collaborators`);
      if (!res.ok) throw new Error("Failed to load collaborators");
      const data = await res.json();
      setCollaborators(data);
      setError(null);
    } catch (err) {
      // API not reachable yet — fall back to dummy data so the UI can be previewed
      console.warn("Falling back to dummy collaborators:", err.message);
      setCollaborators(DUMMY_COLLABORATORS);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollaborators();
  }, []);

  const handleDelete = async (id, companyName) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete "${companyName}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e0432c",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "No, cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/collaborators/${id}`, {
        method: "DELETE",
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.error || "Failed to delete collaborator");
      }

      setCollaborators((prev) => prev.filter((c) => c.id !== id));

      Swal.fire({
        title: "Deleted!",
        text: `"${companyName}" has been deleted.`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.message || "Something went wrong. Please try again.",
        icon: "error",
      });
    }
  };
  const filtered = collaborators.filter((c) => {
    const q = query.toLowerCase().trim();
    if (!q) return true;
    return [
      c.companyName,
      c.contactName,
      c.contactNumber,
      c.businessEmail,
      c.companyOverview,
    ]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(q));
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [query, pageSize]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  const paginated = filtered.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);
    if (start > 2) pages.push("dots-start");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("dots-end");
    pages.push(totalPages);
    return pages;
  };

  const total = collaborators.length;

  return (
    <div className="col-app">
      {/* ---------------- Main content ---------------- */}
      <main className="col-main">
        <header className="col-topbar col-panel">
          <h1>Collaborate Members List</h1>
          <button className="col-logout">
            <LogOut size={14} />
            Logout
          </button>
        </header>

        <section className="col-panel">
          <div className="col-controls">
            <label className="col-show-entries">
              Show Entries :
              <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </label>

            <span className="col-pill col-pill--total">Total Collaborators : {total}</span>

           <button className="col-pill col-pill--export">
  <span className="col-excel-icon-wrap">
    <img
      src="/assets/excel.png"
      alt="Excel"
      className="col-excel-icon col-excel-icon--default"
    />
    <img
      src="/assets/excel-white.png"
      alt="Excel"
      className="col-excel-icon col-excel-icon--hover"
    />
  </span>
  Export To Excel
</button>

            <div className="col-search">
              <Search size={14} />
              <input
                placeholder="Search..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="col-table-outer">
            <div className="col-table-inner">
            {loading ? (
              <p style={{ padding: "20px" }}>Loading collaborators...</p>
            ) : error ? (
              <p style={{ padding: "20px", color: "#e0432c" }}>{error}</p>
            ) : (
              <table className="col-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Company Name</th>
                    <th>Contact Name</th>
                    <th>Contact Number</th>
                    <th>Business Email</th>
                    <th>Website Link</th>
                    <th>Privacy Agreed</th>
                     <th>Company Overview</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginated.length === 0 ? (
                    <tr>
                     <td colSpan={9} style={{ padding: "20px", textAlign: "center" }}>
                        No collaborators yet.
                      </td>
                    </tr>
                  ) : (
                    paginated.map((c, index) => (
                      <tr key={c.id}>
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{c.companyName}</td>
                        <td>{c.contactName}</td>
                        <td>{c.contactNumber}</td>
                        <td>{c.businessEmail}</td>
                        <td>
                          {c.websiteLink ? (
                            <a
                              href={c.websiteLink}
                              target="_blank"
                              rel="noreferrer"
                              className="col-link"
                            >
                              View Website
                            </a>
                          ) : (
                            "—"
                          )}
                        </td>
                        <td>{c.privacyAgreed ? "Yes" : "No"}</td>
                       <td className="col-overview-cell" title={c.companyOverview}>
                          {c.companyOverview}
                        </td>
                        <td>
                          <button
                            className="col-delete-btn"
                            onClick={() => handleDelete(c.id, c.companyName)}
                          >
                            <Trash2 size={14} />
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
            </div>
          </div>

          <div className="col-table-footer">
            <span>
              Showing {paginated.length === 0 ? 0 : (currentPage - 1) * pageSize + 1}
              &ndash;
              {(currentPage - 1) * pageSize + paginated.length} of {filtered.length} Members
            </span>
            <div className="col-pagination">
              <button
                className="col-page-btn"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeft size={14} />
              </button>
              {getPageNumbers().map((p, i) =>
                p === "dots-start" || p === "dots-end" ? (
                  <span key={`${p}-${i}`} className="col-page-dots">
                    …
                  </span>
                ) : (
                  <button
                    key={p}
                    className={`col-page-btn${p === currentPage ? " active" : ""}`}
                    onClick={() => goToPage(p)}
                  >
                    {p}
                  </button>
                )
              )}
              <button
                className="col-page-btn"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <ChevronRight size={14} />
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
